<template>
    <div class="groupFields" :class="{ 'onlyView': getPermissionAction }">
        <div class="groupField">
            <div class="groupFieldTitle">
                <div class="groupFieldTitle_description">
                    <span>Users</span>
                    <warn-block margin="0 0 0 15px" text="By default user without subrole has Customer's permissions."></warn-block>
                </div>
	            <v-btn
			            @click="onAddItem" type="button"
			            depressed
			            class="mainBtn mainBtn-text"
	            >
		            <span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
		            <span class="btnText">Add new user</span>
	            </v-btn>
            </div>
            <template v-for="(item, idx) in usersList">
                <div class="groupField_wrap" :key="idx">
                    <field
                        margin="0 10px 10px 0"
                        width="300px"
                        label="Subrole"
                        placeholder="Select subrole"
                        :idx="idx"
                        @updateSelect="onInput($event, 'type')"
                        :autocompleteValue="item.type"
                        :items="usersGroup"
                        is-select
                    ></field>
                    <field
                        :classError="valid.users.$each.$iter[idx]['name'].$error"
                        width="300px"
                        margin="0 10px 10px 0"
                        :idx="idx"
                        label="Name"
                        placeholder="Enter name"
                        @updateInput="onInput($event, 'name')"
                        :setInputValue="item.name"
                        is-required
                    ></field>
                    <field
                        :classError="valid.users.$each.$iter[idx]['email'].$error || item.error"
                        width="300px"
                        margin="0 10px 10px 0"
                        label="Email"
                        placeholder="Enter email"
                        @updateInput="onInput($event, 'email')"
                        :idx="idx"
                        :setInputValue="item.email"
                        is-clip
                        is-required
                    ></field>
                    <field
                        :classError="valid.users.$each.$iter[idx]['pass'].$error"
                        width="300px"
                        margin="0 10px 10px 0"
                        label="Password"
                        type="password"
                        placeholder="Enter password"
                        @updateInput="onInput($event, 'pass')"
                        :idx="idx"
                        :setInputValue="item.pass"
                        is-pass
                        is-clip
                        is-required
                    ></field>
                    <field
                        :classError="valid.users.$each.$iter[idx]['confirmPass'].$error"
                        width="330px"
                        type="password"
                        margin="0 10px 10px 0"
                        label="Confirm password"
                        placeholder="Enter confirm password"
                        @updateInput="onInput($event, 'confirmPass')"
                        :setInputValue="item.confirmPass"
                        :idx="idx"
                        is-pass
                        is-clip
                        is-required
                    ></field>
                    <v-switch
                        class="switchFrozen"
                        v-model="item.status"
                        :label="`${item.status ? 'Active' : 'Inactive' } user status`"
                        color="success"
                        hide-details
                        @change="onSwitch"
                    ></v-switch>
                    <button type="button" class="deleteItem" @click="onDeleteItem(idx, 'dnuList')">
                        <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
// components
import WarnBlock from "@/shared/WarnBlock/WarnBlock";

export default {
	name: "FifthTab",
	components: {
		WarnBlock
	},
	props: {
		valid: Object,
		getPermissionAction: Boolean,
		users: {
			type: Array,
			default: () => []
		},
		usersGroup: Array
	},
	data: () => ({
		usersList: []
	}),
	methods: {
		getData() {
			this.$emit('updateData', { ...this.$data });
		},
		onSwitch() {
			this.getData();
		},
		onAddItem() {
			const value = {
				type: null,
				name: '',
				id: null,
				email: '',
				pass: '',
				confirmPass: '',
				status: false
			};

			this.usersList.push(value);
			this.getData();
		},
		onInput({ value, idx }, key) {
			const isEmail = key === 'email';
			const inputValue = isEmail ? value.toLowerCase() : value;

			if (isEmail) {
				this.usersList[idx]['error'] = this.usersList.some(item => item.email === inputValue);
			}

			this.usersList[idx][key] = inputValue;
			this.getData();
		},
		onDeleteItem(idx) {
			this.usersList.splice(idx, 1);
			this.getData();
		}
	},
	mounted() {
		this.usersList = this.users.map(item => {
			item.error = false;
			return item;
		});
	}
};
</script>

<style scoped lang="scss">
@import "FifthTab";
</style>
